var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[(_vm.enableOverlay)?_c('Loading',{attrs:{"active":_vm.dataLoading || _vm.showError,"is-full-page":false,"color":"springGreen","backgroundColor":"culturedGray","opacity":0.75}},[(_vm.showError)?_c('DataNotLoaded'):_vm._e()],1):_vm._e(),(!_vm.renderAfterLoad || !_vm.dataLoading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }